module.exports = __webpack_public_path__ + "img/parent@2x.153a6fb7.png";